export const BANNER = 'BANNER'
export const BANNER_WITH_BULLETS = 'BANNER_WITH_BULLETS'
export const BANNER_WITH_BULLETS_AND_PLAYER = 'BANNER_WITH_BULLETS_AND_PLAYER'
export const ONE_LINE = 'ONE_LINE'
